import { useEffect, useState } from "react";
import { Amplify, API } from "aws-amplify";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { Alert } from "@mui/material";
import { AuthState } from "@aws-amplify/ui-components";
import awsconfig from "./aws-exports";
import { useAuth } from "./hooks/useAuth";

import Home from "./pages/Home/Home";
import Login from "./pages/Login";
import Alumni from "./pages/Alumni/Alumni";
import PrivateRoute from "./components/PrivateRoute";
// import Employers from "./pages/Employers";
// import Jobs from "./pages/Jobs";
// import Job from "./pages/Job";
// import Cohort from "./pages/Cohort";
import Alum from "./pages/Alum";
import Admin from "./pages/Admin";
// import Events from "./pages/Events";
// import Feed from "./pages/Feed";
import Navbar from "./components/Navbar/Navbar";
import Layout from "./components/Layout/Layout";
import * as Routes from "./constants/routes";
import muiTheme from "./styles/materialUi/theme";
import { listCohorts } from "./graphql/queries";

Amplify.configure(awsconfig);

const App = () => {
  const [cohorts, setCohorts] = useState({});
  const [cohortsItems, setCohortsItems] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const auth = useAuth();

  useEffect(() => {
    const fetchAndSetCohorts = async () => {
      try {
        const fetchedData = await API.graphql({
          query: listCohorts,
        });
        if (fetchedData?.data?.listCohorts?.items?.length > 0) {
          setCohortsItems(fetchedData.data.listCohorts.items);
          const cohortsById = {};
          fetchedData.data.listCohorts.items.forEach((cohort) => {
            cohortsById[cohort.id] = {
              name: cohort.name,
              year: cohort.year,
            };
          });
          setCohorts(cohortsById);
        } else {
          setErrorMsg(
            "Cohorts data is not available. If you are an admin, please verify if cohorts data is uploaded."
          );
        }
      } catch (e) {
        setErrorMsg("Something went wrong. Application may not work properly.");
      }
    };

    if (auth.authState === AuthState.SignedIn) {
      fetchAndSetCohorts();
    }
  }, [auth.authState]);

  const updateCohortsStates = (updatedCohort) => {
    setCohortsItems((prevCohorts) => {
      const newCohorts = [...prevCohorts];
      const cohortIndex = prevCohorts.findIndex(
        (cohort) => cohort.id === updatedCohort.id
      );
      if (cohortIndex === -1) {
        newCohorts.push(updatedCohort);
      } else {
        newCohorts[cohortIndex] = updatedCohort;
      }
      return newCohorts;
    });
    setCohorts((prevCohorts) => ({
      ...prevCohorts,
      [updatedCohort.id]: {
        name: updatedCohort.name,
        year: updatedCohort.year,
      },
    }));
  };

  return (
    <ThemeProvider theme={muiTheme}>
      <BrowserRouter>
        <Navbar />
        {errorMsg && <Alert severity="error">{errorMsg}</Alert>}
        <Layout>
          <Switch>
            <Route exact path={Routes.HOME} render={() => <Home />} />
            <Route exact path={Routes.LOGIN} render={() => <Login />} />
            {/* <Route exact path={Routes.EVENTS} render={() => <Events />} /> */}
            {/* <PrivateRoute
              allowedGroups={new Set(["admin", "alumni", "employers"])}
              exact
              path={Routes.FEED}
            >
              <Feed />
            </PrivateRoute> */}
            <PrivateRoute
              allowedGroups={new Set(["admin"])}
              exact
              path={Routes.ADMIN}
            >
              <Admin
                cohorts={cohortsItems}
                updateCohortsStates={updateCohortsStates}
              />
            </PrivateRoute>
            <PrivateRoute
              allowedGroups={new Set(["admin", "alumni", "employers"])}
              exact
              path={Routes.ALUMNI}
            >
              <Alumni cohorts={cohorts} />
            </PrivateRoute>
            <PrivateRoute
              allowedGroups={new Set(["admin", "alumni", "employers"])}
              exact
              path={Routes.ALUM}
            >
              <Alum cohorts={cohorts} />
            </PrivateRoute>
            {/* <PrivateRoute
              allowedGroups={new Set(["admin", "alumni"])}
              exact
              path={Routes.COHORT}
            >
              <Cohort cohorts={cohorts} />
            </PrivateRoute> */}
            {/* <PrivateRoute
              allowedGroups={new Set(["admin", "employers"])}
              exact
              path={Routes.EMPLOYERS}
            >
              <Employers />
            </PrivateRoute>
            <PrivateRoute
              allowedGroups={new Set(["admin", "alumni"])}
              exact
              path={Routes.JOBS}
            >
              <Jobs />
            </PrivateRoute> */}
            {/* <PrivateRoute
              allowedGroups={new Set(["admin", "alumni"])}
              exact
              path={Routes.JOB}
            >
              <Job />
            </PrivateRoute> */}
            <Route render={() => <Login />} />
          </Switch>
        </Layout>
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default App;
